import AddressFields from '~/components/AddressFields';
import Alert from '~/components/Alert';
import Card from '~/components/Card';
import Form from '~/components/Form';
import Page from '~/components/Page';
import Submit from '~/components/Submit';
import { useIsLoading } from '~/utils/routing';
import { useActionResult, useLoaderData } from './editAddress';

export default function EditAddressPage() {
  const { address, requirePhone } = useLoaderData();
  const actionResult = useActionResult();
  const isLoading = useIsLoading();

  return (
    <Page headline="Update Address">
      <Card>
        <Form name="addressForm">
          <AddressFields address={address} requirePhone={requirePhone} />
          {actionResult?.ok === false && (
            <Alert variant="error" title="Invalid address">
              Please check your information is correct.
            </Alert>
          )}
          <Submit loading={isLoading}>Next</Submit>
        </Form>
      </Card>
    </Page>
  );
}
